/*
 * HTML5 Sortable jQuery Plugin
 * http://farhadi.ir/projects/html5sortable
 *
 * Copyright 2012, Ali Farhadi
 * Released under the MIT license.
 */
(function ($) {
  var dragging, placeholders = $();  
  $.fn.sortable = function (options) {
    var method = String(options);
    options = $.extend({
      connectWith: false,
      placeholderClass: ''
    }, options);
    return this.each(function () {
      if (/^enable|disable|destroy$/.test(method)) {
        var dragitems = $(this).children($(this).data('items')).attr('draggable', method == 'enable');
        if (method == 'destroy') {
          dragitems.add(this).removeData('connectWith items')
            .off('dragstart.h5s dragend.h5s selectstart.h5s dragover.h5s dragenter.h5s drop.h5s');
        }
        return;
      }
      var isHandle, parent, index, items = $(this).children(options.items);
      var placeholder = $('<' + (/^ul|ol$/i.test(this.tagName) ? 'li' : /^tbody$/i.test(this.tagName) ? 'tr' : 'div') +
                          ' class="sortable-placeholder ' + options.placeholderClass + '">').html('&nbsp;');
      items.find(options.handle).mousedown(function () {
        isHandle = true;
      }).mouseup(function () {
        isHandle = false;
      });
      $(this).data('items', options.items)
      placeholders = placeholders.add(placeholder);
      if (options.connectWith) {
        $(options.connectWith).add(this).data('connectWith', options.connectWith);
      }
      items.attr('draggable', 'true').on('dragstart.h5s', function (e) {
        if (options.handle && !isHandle) {
          return false;
        }
        isHandle = false;
        var dt = e.originalEvent.dataTransfer;
        dt.effectAllowed = 'move';
        dt.setData('Text', 'dummy');
        index = (dragging = $(this)).addClass('sortable-dragging').index();
        parent = dragging.parent();
      }).on('dragend.h5s', function () {
        if (!dragging) {
          return;
        }
        dragging.removeClass('sortable-dragging').show();
        placeholders.detach();
        if (index != dragging.index()) {
          dragging.parent().trigger('sortupdate', {
            item: dragging
          });
        }
        if (!dragging.parent().is(parent)) {
          dragging.parent().trigger('sortconnect', {
            item: dragging
          });
        }
        dragging = null;
      }).not('a[href], img').on('selectstart.h5s', function () {
        this.dragDrop && this.dragDrop();
        return false;
      }).end().add([this, placeholder]).on('dragover.h5s dragenter.h5s drop.h5s', function (e) {
        if (!items.is(dragging) && options.connectWith !== $(dragging).parent().data('connectWith')) {
          return true;
        }
        if (e.type == 'drop') {          
          e.stopPropagation();
          placeholders.filter(':visible').after(dragging);
          dragging.trigger('dragend.h5s');
           var curchildren = e.currentTarget.children         
           var arrCurrentCollaboration = $('.currentCollaboration');
           console.log("curchildren ==", curchildren);           
          
          //  Add noAssignment message for Collaboration if assignmentsection available
          for (let i = 0 ; i < arrCurrentCollaboration.length ; i++) 
          {
              var assignmentsectionDiv = $($(arrCurrentCollaboration[i]).children()).closest('.div-sortable').children().closest('.assignmentsection');
              console.log('assignmentsectionDiv ==>', assignmentsectionDiv)

              var firstAssignmentsectionDivtlength = assignmentsectionDiv.length;
              var assignmentsectionDivChildrens = $(assignmentsectionDiv.children())
              var myDivClasses; // = assignmentsectionDivChildrens[1].classList;

            if (assignmentsectionDivChildrens != undefined && assignmentsectionDivChildrens.length > 0) {
              myDivClasses = assignmentsectionDivChildrens[1].classList;
            }
              // Start - Show/Hide First assignmentsection img
             // if (i == 0) {               

                if (firstAssignmentsectionDivtlength == 1) {
                  console.log('myDivClasses', myDivClasses);
                  if (myDivClasses != undefined) {
                    if (myDivClasses.contains("list-group-item")) {
                      myDivClasses.remove("list-group-item");
                    }
                  }
                   assignmentsectionDiv[0].draggable = false;
                  // $(assignmentsectionDivChildrens[1]).children(":first").hide();
                  if (assignmentsectionDivChildrens != undefined && assignmentsectionDivChildrens != null) {
                    assignmentsectionDivChildrens.find("img").css({"display": "none"}); 
                  }

                  console.log('length is one', firstAssignmentsectionDivtlength);
                } 
                else if (firstAssignmentsectionDivtlength > 1)
                {
                //   // if (!myDivClasses.contains("list-group-item")) {                    
                //     myDivClasses.add("list-group-item");
                //     assignmentsectionDiv[0].draggable = true;                    
                //  // $(assignmentsectionDivChildrens[i]).children(":first").show();
                //     assignmentsectionDivChildrens.find("img").css({"display": "inline-block"});
                // //  }
                  console.log('length is greater than one', firstAssignmentsectionDivtlength);
                }
              //} // End - Hide/show img

              for (let c = 0; c < assignmentsectionDiv.length; c++) {

                let assignmentCode = $(assignmentsectionDiv[c]).find('#hdnAssignmentCode').val();
                
                if((firstAssignmentsectionDivtlength == 1) || !assignmentCode || assignmentCode.toString().trim().length == 0){
                  $(assignmentsectionDiv[c]).find("img").css({"display": "none"});
                  $(assignmentsectionDiv[c]).attr('draggable', 'false');
                  $(assignmentsectionDiv[c]).removeClass('list-group-item');
                }
                else{
                  $(assignmentsectionDiv[c]).find("img").css({"display": "inline-block"});
                  $(assignmentsectionDiv[c]).attr('draggable', 'true');
                  $(assignmentsectionDiv[c]).addClass('list-group-item');
                }
              }

              // Start - Restrict First assignmentsection Row for drag and drop 
              if (assignmentsectionDiv == undefined || assignmentsectionDiv.length == 0) {                  
                   var noAssignmentDiv = $($(arrCurrentCollaboration[i]).children()).closest('.div-sortable').find('.noAssignment');
                   if (noAssignmentDiv.length > 0)
                    {
                      $(noAssignmentDiv).attr('style','display:block');
                     
                   }
                   else  {
                    var warningLabel='<div class="row m-1 pl-4 noAssignment" draggable="true"><span class="label error-color px-2" id="warningLabelAssignment">Please add an assignment</span></div>' 
                    $($(arrCurrentCollaboration[i]).children()).closest('.div-sortable').append(warningLabel);                  
                   }
              }             
          }    // For Loop end           

           for (let i = 0 ; i < curchildren.length ; i++) {                      

             if ($(curchildren[i]).hasClass('noAssignment'))
             {
              curchildren[i].setAttribute('style','display:none');
             }
           }
          return false;
        } //End Drop
        
        e.preventDefault();
        e.originalEvent.dataTransfer.dropEffect = 'move';

        if (items.is(this)) {
          if (options.forcePlaceholderHeight || options.forcePlaceholderSize) {
            placeholder.height(dragging.outerHeight());
          }
          if (options.forcePlaceholderWidth || options.forcePlaceholderSize) {
            placeholder.width(dragging.outerWidth());
          }
          dragging.hide();
          $(this)[placeholder.index() < $(this).index() ? 'after' : 'before'](placeholder);
          placeholders.not(placeholder).detach();
        } else if (!placeholders.is(this) && !$(this).children(options.items).length) {
          placeholders.detach();         
          $(this).append(placeholder);
        }
        return false;
      });
    });
  };
})(jQuery);
